import ActiveTrialNavItem from './ActiveTrialNavItem';

export default ActiveTrialNavItem;
